import { isInvoiceProfileComplete } from './invoiceProfile';
import { DOCUMENT_TYPES, REQUIRED_KEYS, documentState } from './driverDocuments';

// Punktene i «Dokumenter og godkjenning»: status og neste steg, utledet av feltene som allerede finnes.
// status: 'ok' | 'pending' | 'missing' | 'blocked'. action: knapp til neste steg, eller null.
export function buildApprovalItems({ userDoc, vehicle, cardEnabled = true }) {
  const items = [];

  const status = userDoc?.driverStatus;
  if (status === 'active') {
    items.push({ key: 'approval', title: 'Godkjenning fra Tippi', status: 'ok', statusLabel: 'Godkjent', next: 'Du er godkjent og kan ta oppdrag.', action: null });
  } else if (status === 'rejected') {
    items.push({ key: 'approval', title: 'Godkjenning fra Tippi', status: 'blocked', statusLabel: 'Avslått', next: 'Søknaden ble avslått. Kontakt Tippi for å høre hva som mangler.', action: null });
  } else if (status === 'frozen') {
    items.push({ key: 'approval', title: 'Godkjenning fra Tippi', status: 'blocked', statusLabel: 'Pauset', next: 'Kontoen din er satt på pause. Kontakt Tippi for å åpne den igjen.', action: null });
  } else {
    items.push({ key: 'approval', title: 'Godkjenning fra Tippi', status: 'pending', statusLabel: 'Venter godkjenning', next: 'Venter på godkjenning fra Tippi. Du får varsel når den er behandlet.', action: null });
  }

  // Org-sjåfører styres av transportfirmaet: kjøretøy og fakturaprofil er firmaets, ikke sjåførens.
  const inOrg = !!userDoc?.carrierOrgId;

  if (inOrg) {
    // hoppes over
  } else if (!vehicle) {
    items.push({ key: 'vehicle', title: 'Kjøretøy', status: 'missing', statusLabel: 'Mangler', next: 'Legg inn kjøretøyet ditt så vi vet hva du kjører.', action: { key: 'vehicle', label: 'Legg til kjøretøy' } });
  } else if (!vehicle.registrationPlate) {
    items.push({ key: 'vehicle', title: 'Kjøretøy', status: 'missing', statusLabel: 'Mangler', next: 'Registreringsnummer mangler på kjøretøyet.', action: { key: 'vehicle', label: 'Fullfør kjøretøy' } });
  } else {
    items.push({ key: 'vehicle', title: 'Kjøretøy', status: 'ok', statusLabel: 'Registrert', next: `${vehicle.registrationPlate} er registrert.`, action: null });
  }

  if (inOrg) {
    // hoppes over
  } else if (isInvoiceProfileComplete(userDoc?.invoiceProfile)) {
    items.push({ key: 'invoice', title: 'Utbetaling og fakturering', status: 'ok', statusLabel: 'Komplett', next: 'Kontonummer og fakturaopplysninger er lagret.', action: null });
  } else {
    items.push({ key: 'invoice', title: 'Utbetaling og fakturering', status: 'missing', statusLabel: 'Mangler', next: 'Fyll ut utbetaling og fakturering for å kunne ta oppdrag.', action: { key: 'invoice', label: 'Fyll ut' } });
  }

  if (!inOrg) {
    REQUIRED_KEYS.forEach((key) => {
      const title = DOCUMENT_TYPES[key].label;
      const doc = userDoc?.documents?.[key];
      const state = documentState(doc);
      const upload = { key: 'documents', label: 'Last opp' };
      const reupload = { key: 'documents', label: 'Last opp på nytt' };
      const itemKey = `doc-${key}`;
      if (state === 'approved') {
        items.push({ key: itemKey, title, status: 'ok', statusLabel: 'Godkjent', next: `${title} er godkjent.`, action: null });
      } else if (state === 'pending') {
        items.push({ key: itemKey, title, status: 'pending', statusLabel: 'Til godkjenning', next: 'Tippi kontrollerer dokumentet. Du får varsel når det er behandlet.', action: null });
      } else if (state === 'rejected') {
        items.push({ key: itemKey, title, status: 'blocked', statusLabel: 'Avvist', next: `Avvist: ${doc.rejectReason ?? 'kontakt Tippi'}. Last opp et nytt dokument.`, action: reupload });
      } else if (state === 'expired') {
        items.push({ key: itemKey, title, status: 'missing', statusLabel: 'Utløpt', next: `${title} er utløpt. Last opp et gyldig dokument.`, action: reupload });
      } else {
        items.push({ key: itemKey, title, status: 'missing', statusLabel: 'Mangler', next: `Last opp ${title.toLowerCase()} med utløpsdato.`, action: upload });
      }
    });
  }

  // Er kort av, hoppes Stripe-punktet over (en allerede aktiv konto vises fortsatt).
  if (cardEnabled || userDoc?.stripePayoutsEnabled) {
    if (userDoc?.stripePayoutsEnabled) {
      items.push({ key: 'stripe', title: 'Stripe-konto for utbetaling', status: 'ok', statusLabel: 'Aktiv', next: 'Utbetalinger er aktivert.', action: null });
    } else if (userDoc?.stripeDetailsSubmitted) {
      items.push({ key: 'stripe', title: 'Stripe-konto for utbetaling', status: 'pending', statusLabel: 'Under kontroll', next: 'Stripe kontrollerer opplysningene dine. Det kan ta fra noen minutter til et par dager.', action: { key: 'earnings', label: 'Gå til Inntekt' } });
    } else {
      items.push({ key: 'stripe', title: 'Stripe-konto for utbetaling', status: 'missing', statusLabel: 'Ikke koblet til', next: 'Koble til Stripe under Inntekt for å få utbetalinger.', action: { key: 'earnings', label: 'Gå til Inntekt' } });
    }
  }

  return items;
}
